/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export type LayoutLevel = 'small' | 'medium' | 'large';

export interface LayoutConfig {
	windowSizeLevel: LayoutLevel;
	fontSizeLevel: LayoutLevel;
	isExpanded: boolean;
	/** 圖片檢視開啟時外框要佔滿可見範圍。由 FileReviewer 設定，App 讀來算外框 */
	isImageViewerOpen: boolean;
}

const initialState: LayoutConfig = {
	windowSizeLevel: 'small',
	fontSizeLevel: 'small',
	isExpanded: false,
	isImageViewerOpen: false,
};

export const layoutSlice = createSlice({
	name: 'layout',
	initialState,
	reducers: {
		initializeLayoutConfig: (state, action) => {
			const validLevels = ['small', 'medium', 'large'];
			state.windowSizeLevel = validLevels.includes(action.payload.windowSizeLevel) ? action.payload.windowSizeLevel : 'small';
			state.fontSizeLevel = validLevels.includes(action.payload.fontSizeLevel) ? action.payload.fontSizeLevel : 'small';
		},
		setWindowSizeLevel: (state, action) => {
			state.windowSizeLevel = action.payload;
		},
		setFontSizeLevel: (state, action) => {
			state.fontSizeLevel = action.payload;
		},
		setIsExpanded: (state, action) => {
			state.isExpanded = Boolean(action.payload);
		},
		setIsImageViewerOpen: (state, action) => {
			state.isImageViewerOpen = Boolean(action.payload);
		},
	},
});

export const {
	initializeLayoutConfig,
	setWindowSizeLevel,
	setFontSizeLevel,
	setIsExpanded,
	setIsImageViewerOpen,
} = layoutSlice.actions;

export default layoutSlice.reducer;
